/* unplugin-vue-components disabled */import { render } from "./TransferInput.vue?vue&type=template&id=bcd12e9e&scoped=true"
import script from "./TransferInput.vue?vue&type=script&lang=js"
export * from "./TransferInput.vue?vue&type=script&lang=js"

import "./TransferInput.vue?vue&type=style&index=0&id=bcd12e9e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcd12e9e"]])

export default __exports__